// @ts-check
import { useState } from 'react';
import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import { LBButton } from '@linearb/buzz';

const CollapseSection = ({
  disabled,
  children,
  title,
  openButtonText,
  closeButtonText = 'Close',
  onButtonClick = _.noop,
  pl = 'large',
  isCollapsable = true,
  isTitleClickable = false
}) => {
  const [isOpen, setIsOpen] = useState(!isCollapsable);

  const onCollapseSectionClick = () => {
    onButtonClick(isOpen);
    setIsOpen(!isOpen);
  };

  return (
    <Flex
      border={`1px solid ${getColor('botticelli')}`}
      borderRadius='0.35rem'
      backgroundColor={`${getColor('zircon')}66`}
      mt='small'
      pr='medium'
      pl={pl}
      pt='small'
      pb='small'
      direction='column'
    >
      <Flex
        justify='space-between'
        items='center'
        minHeight='2.5rem'
        {...(isTitleClickable && !disabled
          ? {
              onClick: () => onCollapseSectionClick(),
              cursor: 'pointer'
            }
          : {})}
      >
        {_.isFunction(title) ? title(isOpen) : title}
        {isCollapsable && (
          <LBButton
            disabled={disabled}
            variant='outline'
            onClick={() => onCollapseSectionClick()}
          >
            {isOpen ? closeButtonText : openButtonText}
          </LBButton>
        )}
      </Flex>

      {isOpen && !disabled && children}
    </Flex>
  );
};
export default CollapseSection;
